import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Form from "../../../../Componets/Form";
import toast from "react-hot-toast";
import Header from "../../../../Componets/Header";
import forms from "../../../../Data/Forms/Inventory/Sites/forms";
import headers from "../../../../Data/Forms/Inventory/Sites/headers";
import Loadercomponent from "../../../../Componets/Loader";
import { create_site, get_site, update_site } from "../../../../Controllers/Inventory/Sites";

const SitesForm = ({ isModal = false, onClose }) => {
    let { id } = useParams();
    let navigate = useNavigate();

    const [loader, setLoader] = useState(false);
    const [buttonLoader, setButtonLoader] = useState(false);
    const [values, setValues] = useState(forms);
    const [header, setHeader] = useState(headers);

    const formdata = async (data) => {
        if (data?.status) {
            setButtonLoader(true);

            const site = id
                ? await update_site({ id: id, ...data?.data })
                : await create_site(data?.data);

            if (site?.status) {
                if (isModal) {
                    onClose && onClose();
                } else {
                    navigate(-1);
                }
                toast?.success(site?.message);
                setButtonLoader(false);
            } else {
                setButtonLoader(false);
                if (site?.status_code == 403) {
                    window.location.href = "/unauthorized";
                } else {
                    toast?.error(site?.message);
                }
            }
        }
    };

    const handleData = (site) => {
        forms[0].options[0].form.value = site?.name || "";
        forms[0].options[1].form.value = site?.type || "Site";
        forms[0].options[2].form.value = site?.manager || "";

        forms[1].options[0].form.value = site?.address || "";
        forms[1].options[1].form.value = site?.gps_coordinates || "";

        forms[2].options[0].form.value = site?.contact_number || "";
        forms[2].options[1].form.value = site?.notes || "";

        forms[3].options[0].form.value = site?.status ?? 1;

        setLoader(false);
        setValues([...values]);
    };

    const fetchData = async () => {
        if (id) {
            setLoader(true);
            const site = await get_site({ id });
            if (site?.status) {
                handleData(site?.data);
            } else {
                toast?.error(site?.message);
            }
        } else {
            setLoader(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [buttonLoader]);

    const content = (
        <Loadercomponent loader={loader}>
            <Form
                form={values}
                setForm={setValues}
                formdata={formdata}
                buttonLoader={buttonLoader}
                isModal={isModal}
                onModalClose={onClose}
            />
        </Loadercomponent>
    );

    return isModal ? (
        content
    ) : (
        <Header headers={header} setHeaders={setHeader} formdata={formdata}>
            {content}
        </Header>
    );
};

export default SitesForm;